type Props = {
  value: number;
  max: number;
  onChange: (value: number) => void;
};

export default function QuantitieInputBox({value, max, onChange}: Props) {
  return (
    <div className="relative w-full min-h-[44px] h-[2.5625rem] leading-[1.625] border bg-gray-100 border-gray-200 pl-3 pr-10 py-2 text-left focus:outline-none">
      <div className="absolute inset-y-0 right-0 w-full flex items-center">
        <p className="pl-4">{value}</p>

        <div className="flex gap-1 text-gray-500 ml-auto pr-1">
          <button
            type="button"
            id={`${max}-decrement-quantity`}
            aria-label="Decrement quantity"
            disabled={value === 0}
            onClick={() => onChange(value - 1)}
            className="w-6 h-6 text-gray-500 rounded-full border border-gray-500 cursor-pointer flex justify-center items-center disabled:cursor-default disabled:opacity-40">
            <svg
              className="w-7 h-7 fill-current"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 -960 960 960">
              <path d="M200-440v-80h560v80H200Z" />
            </svg>
          </button>
          <button
            type="button"
            id={`${max}-increment-quantity`}
            aria-label="Increment quantity"
            disabled={value === max}
            onClick={() => onChange(value + 1)}
            className="w-6 h-6 text-gray-500 rounded-full border border-gray-500 cursor-pointer flex justify-center items-center disabled:cursor-default disabled:opacity-40">
            <svg
              className="w-7 h-7 fill-current"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 -960 960 960">
              <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
